import axios from 'axios'
import { config } from '../config'

const baseURL = config.apiUrl

export const api = axios.create({
	baseURL: `${baseURL}/v1`,
	withCredentials: true,
	headers: {
		'Content-Type': 'application/json',
	},
	timeout: 15000,
})

// Request interceptor to add auth token
api.interceptors.request.use(config => {
	const token = localStorage.getItem('gp_auth')
	if (token) {
		try {
			const authData = JSON.parse(token)
			if (authData.token) {
				config.headers = config.headers ?? {}
				;(config.headers as any).Authorization = `Bearer ${authData.token}`
			}
		} catch (error) {
			console.error('Failed to parse auth token:', error)
		}
	}
	return config
})

api.interceptors.response.use(
	response => response,
	error => {
		// Handle 401 errors by clearing auth and redirecting to login
		if (error.response?.status === 401) {
			localStorage.removeItem('gp_auth')
			window.location.href = '/'
		}
		const errorToReject = error instanceof Error ? error : new Error(String(error))
		return Promise.reject(errorToReject)
	},
)

export default api
